import { GET_TOPUP_PACKAGES } from "../graphql-saleor/queries/getTopupPackages"
import { client } from "../graphql-saleor/client"
import { useQuery } from "@apollo/client"
import { SELECTED_CHANNEL_SLUG, PRODUCT_FLEXMOVE_TOPUP_SLUG } from "../utils/saleor-constants"

export const useGetTopupPackages = () => {
  const { data, error, loading, refetch } = useQuery(GET_TOPUP_PACKAGES, {
    client: client,
    variables: {
      channelSlug: SELECTED_CHANNEL_SLUG,
      productSlug: PRODUCT_FLEXMOVE_TOPUP_SLUG,
    },
  })
  return {
    topupPackages: data?.product?.variants,
    topupListError: error,
    topupListLoading: loading,
    refetch,
  }
}
